import { HttpClient } from "@angular/common/http";
import { Component, OnInit, Optional, TemplateRef, ViewChild } from "@angular/core";
import { NzModalRef, NzModalService } from "ng-zorro-antd/modal";
import { AccountService } from "../../account.service";

@Component({
  selector: "v4-connect-with-booking",
  templateUrl: "./connect-with-booking.component.html",
  styleUrls: ["./connect-with-booking.component.scss"],
})
export class V4ConnectWithBookingComponent implements OnInit {
  showSteps = false;
  step = 1;

  username;
  hotelIds = [{ value: null }];
  loading = false;

  carouselImgs = [
    // 'https://oss.image.xiaogetech.com/ANK1679541743104.png',
    // 'https://oss.image.xiaogetech.com/HPU1679541765155.png',
    "https://oss.image.xiaogetech.com/MOU1679541782135.png",
    // 'https://oss.image.xiaogetech.com/JOO1679541799559.png',
    "https://oss.image.xiaogetech.com/BJO1694157282057.png",
    "https://oss.image.xiaogetech.com/MWS1679541817654.png",
    "https://oss.image.xiaogetech.com/ITG1679541835747.png",
    "https://oss.image.xiaogetech.com/KBK1679541852407.png",
    "https://oss.image.xiaogetech.com/GBT1679541871563.png",
  ];

  constructor(
    private http: HttpClient,
    @Optional() private modalRef: NzModalRef,
    private modal: NzModalService,
    private accountSrv: AccountService,
  ) {}

  ngOnInit() {}

  private requestAuth() {
    const params = {
      username: this.username,
      hotel_ids: this.hotelIds?.map((i) => i.value),
    };
    return this.accountSrv.accountAuth("booking", params);
    // return this.http.post('/api/thirdparty/auth/booking', params);
  }

  onCancel() {
    this.modalRef?.destroy();
  }

  onAuth() {
    this.showSteps = true;
    // this.modal.create({
    //   nzTitle: null,
    //   nzContent: this.steps,
    //   nzWidth: this.modalRef.getConfig().nzWidth,
    // });
  }

  onNext() {
    if (this.step === 3 && this.hotelIds.length === 1) {
      window.open(
        "https://admin.booking.com/hotel/hoteladmin/extranet_ng/manage/channel-manager/widget.html?provider_id=1570&hotel_id=" +
          this.hotelIds[0].value,
      );
      // this.requestAuth().subscribe((rst: any) => {
      //   if (rst.error_code === 0) {
      //     this.modalRef?.destroy("complete");
      //   }
      // });
      this.step = 5;
      // this.modalRef.destroy("complete");
    } else {
      this.step = this.step + 1;
    }
  }

  onAddHotelId() {
    this.hotelIds.push({ value: null });
  }

  onRemoveHotelId(index) {
    this.hotelIds.splice(index, 1);
  }

  onComplete() {
    this.loading = true;
    this.requestAuth().subscribe((rst: any) => {
      this.loading = false;
      if (rst.error_code === 0) {
        // this.step = 6;
        this.modalRef?.destroy("success");
      }
    });
  }

  onFinish() {
    this.modalRef?.destroy("success");
  }
}
